import {Component, EventEmitter, OnInit, Output} from '@angular/core';
import {ROUTES} from './menu-items';
import {Router} from '@angular/router';
import {LoanService} from '../../shared-component/service/loan/loan.service';
import { ReportschemasService } from '../../shared-component/service/reportschema/service';
import {PermissionService} from '../../shared-component/service/permission/permission.service';
import {BehaviorSubject, Observable} from 'rxjs';

@Component({
  selector: 'ap-sidebar',
  templateUrl: './sidebar.component.html',
  styleUrls: ['./sidebar.component.scss']
})
export class SidebarComponent implements OnInit {

  showMenu: any = '';
  showSubMenu: any = '';
  public sidebarnavItems: any[];
  public profileData: any = {};
  public permissionItems: any[];
  public dateRange: any = 0;
  private changeLoanCount = new BehaviorSubject({});
  currentCount = this.changeLoanCount.asObservable();


  @Output() closeSideBar = new EventEmitter();

  constructor(
    public router: Router,
    public loanService: LoanService,
    private permissionProvider: PermissionService,
    private reportschemasProvicer: ReportschemasService
  ) {
  }


  addExpandClass(element: any) {
    if (element === this.showMenu) {
      this.showMenu = false;
    } else {
      if (element === 'Application Status') {
        this.loanService.getApplicationCount().subscribe((res: any) => {
          const applications = ROUTES.find(route => route.title === 'Application Status');
          let total = res.data.reduce((a, i) => { return a + i.total }, 0);

          for (let menu of applications.submenu) {
            if (menu.title === 'All') {
              menu['countAll'] = total;
              menu["color"] = "bg-gray";
              continue;
            }
            menu['countAll'] = 0;
            menu["color"] = "bg-orange";
            let result = res.data.filter(item => {
              if (menu.id == 'applicationPS' && item.status <= 5) {
                menu["color"] = "bg-blue";
                return true;
              } else if (menu.id == 'applicationCS' && item.status > 5 && item.status <= 9) {
                menu["color"] = "bg-green";
                return true;
              } else if (menu.id == 'applicationCR' && (item.status == 12 || item.status == 13 || item.status == 14)) {
                menu["color"] = "bg-darkred";
                return true;
              } else if (menu.id == 'applicationLR' && (item.status == 11 && item.underReview == 'NONE')) {
                menu["color"] = "bg-red";
                return true;
              } else if (menu.id == 'applicationAllCR' && (item.status == 11 || item.status == 5) && item.underReview == "CREDIT") {
                menu["color"] = "bg-orange";
                return true;
              } else if (menu.id == 'applicationAllSR' && (item.status == 11 || item.status == 5) && item.underReview == "SALES") {
                menu["color"] = "bg-orange";
                return true;
              }
            });
            menu['countAll'] = result.reduce((a, i) => { return a + i.total }, 0);
          }
          this.sidebarnavItems = ROUTES;
        });
      }
      else if (element === 'Loans') {   // <------ ADD THIS
        this.getLoanCount();            // <------ ADD THIS
      }
      this.showMenu = element;
    }
  }

  navigateToLoans(path) {
    this.router.navigateByUrl(`${path}`).then();
  }

  addActiveClass(element: any) {
    if (element === this.showSubMenu) {
      this.showSubMenu = false;
    } else {
      this.showSubMenu = element;
    }
  }

  ngOnInit() {
    this.loanService.profile().subscribe((res: any) => {
      this.profileData = res.data;
      this.getPermissionList();
    });
    
    this.loanService.currentCount.subscribe(params => {
      this.dateRange = params;
      this.getLoanCount();
    });
  }

  navigation(path) {
    this.router.navigateByUrl(path).then();
    if (window.innerWidth <= 767) {
      this.closeSideBar.emit();
    }
  }

  getPermissionList(params: any[] = []) {
    try {
      let reportMenu = [];
      this.reportschemasProvicer.getMenuItems().subscribe((res: any) => {
        reportMenu = res.data;

        this.permissionProvider.getAccessList({
          name: 'accessType',
          value: 1
        }).subscribe((res: any) => {
          this.permissionItems = res.data;
          this.permissionProvider.setAccess(res.data);
          let submenu = { 
            "dashboard" : {},
            "reports" : {}
          };

          reportMenu.map(o => {
            let permission = o.permission ? JSON.parse(o.permission) : [];
            let type = o.isDashboard==1?"dashboard":"reports";

            if (!submenu[type][o.menuPath]) {
              submenu[type][o.menuPath] = {
                id: o.reportCode,
                path: '/'+ type + '/' + o.menuPath.replace(/\s/g, '').toLowerCase(),
                title: o.menuName,
                icon: '',
                class: 'has-arrow pt-0',
                label: '',
                labelClass: '',
                extralink: false,
                submenu: [],
                accessCode: permission.length ? [permission[0]] : []
              };
            }

            let item = {
              id: o.reportCode,
              path: '/' + type + '/' + o.menuPath.replace(/\s/g, '').toLowerCase() + '/' + o.reportCode,
              title: o.menuName,
              icon: '',
              label: '',
              labelClass: '',
              extralink: false,
              submenu: [],
              accessCode: permission
            };

            submenu[type][o.menuPath].submenu.push(item);
          });

          const mergerMenu = function (menu1, menu2) {
            let finalmenu = [];
            let menu1Items = menu1.reduce((acc, item) => {
              acc[item.title] = item;
              return acc;
            }, {});

            let menu2Items = menu2.reduce((acc, item) => {
              acc[item.title] = item;
              return acc;
            }, {});

            for (let item in menu1Items) {
              if (menu2Items[item]) {
                menu1Items[item].submenu = mergerMenu(menu1Items[item].submenu, menu2Items[item].submenu)
              }
              finalmenu.push(menu1Items[item]);
            }
            for (let item in menu2Items) {
              if (!menu1Items[item]) {
                finalmenu.push(menu2Items[item]);
              }
            }
            return finalmenu;
          };

          this.sidebarnavItems = [];
          ROUTES.map( ( o ) => {
            if (submenu[o.id]) {
              if(o.id == "dashboard"){
                if((Object.keys(submenu.dashboard)).length == 0 ){
                  o.path = '/application';
                } else {
                  let tmp = Object.values(submenu[o.id]);
                  o.path = tmp[0]["submenu"][0].path; 
                  if(tmp.length == 1 && tmp[0]["submenu"].length == 1){
                      return o;
                  } 
                }
              }
              o.submenu = mergerMenu(o.submenu, Object.values(submenu[o.id]));
            }
            if(o.id == "partnerbranch"){
              if(this.profileData.switchBranch){
                this.sidebarnavItems.push(o);
              }
            } else {
              this.sidebarnavItems.push(o);
            }
          });

          //(this.sidebarnavItems);
        });
      });
    } catch (e) {
      this.sidebarnavItems = ROUTES;
      this.permissionItems = this.permissionProvider.getAccess();
    }
  }
  getLoanCount() {
    if (!this.sidebarnavItems) return;

    const now = new Date();
    const startDate = new Date(now.getFullYear(), now.getMonth(), 1);
    const endDate = new Date(now.getFullYear(), now.getMonth() + 1, 0, 23, 59, 59);
  
    const formatDate = (date: Date) => {
      const y = date.getFullYear();
      const m = String(date.getMonth() + 1).padStart(2, '0');
      const d = String(date.getDate()).padStart(2, '0');
      const h = String(date.getHours()).padStart(2, '0');
      const min = String(date.getMinutes()).padStart(2, '0');
      const s = String(date.getSeconds()).padStart(2, '0');
      return `${y}-${m}-${d} ${h}:${min}:${s}`;
    };
  
    const params = {
      startDate: formatDate(startDate),
      endDate: formatDate(endDate)
    };
  
    this.loanService.getLoanCount(params).subscribe((res: any) => {
    console.log("### API Response:", res.data); // Debug API response

      const loans = this.sidebarnavItems.find(route => route.title === 'Loans');
      let total = res.data.reduce((a, i) => {
        if (!i.tradeLoan) {
          return a + parseInt(i.total);
        }
        return a;
      }, 0);
  
      for (let menu of loans.submenu) {
        if (menu.title === 'All') {
          menu['countAll'] = total;
          menu["color"] = "bg-gray";
          continue;
        }
  
        menu['countAll'] = 0;
  
        switch (menu.id) {
          case 'loansEmandate':
            menu["color"] = "bg-blue";
            break;
          case 'loansToDisburse':
          menu["color"] = "bg-green";
          break;
          case 'loansRunning':
            menu["color"] = "bg-green";
            break;
          case 'loansCancelledRejected':
            menu["color"] = "bg-darkred";
            break;
          case 'loansClosed':
          menu["color"] = "bg-red";
          break;
          case 'loansWriteOffClosed':
            menu["color"] = "bg-red";
            break;
          case 'loansVerify':
          menu["color"] = "bg-orange";
          break;
          case 'tradeLoans':
            menu["color"] = "bg-orange";
            break;
        }
  
        let result = res.data.filter(item => {
          if (menu.id === 'loansVerify' && item.isVerified === 0 && item.status === "active" && item.loanStatus === "PROCESSED" && !item.tradeLoan) return true;
          if (menu.id === 'loansToDisburse' && item.isVerified === 1 && item.status === "active" && item.loanStatus === "PROCESSED" && !item.tradeLoan) return true;
          if (menu.id === 'loansEmandate' && item.emandate && (item.eSignDataValue == null || item.eSignDataValue === 'null') && !item.tradeLoan) return true;
          if (menu.id === 'loansRunning' && (item.status === "active" || item.status === "delinquent") && (item.loanStatus === "PROCESSING" || item.loanStatus === "DISBURSED") && !item.tradeLoan) return true;
          return false;
        });
  
        menu['countAll'] = result.reduce((a, i) => a + parseInt(i.total), 0);
      }
    });
  }


}
